<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-toolbar class="primary white--text">
        <v-flex xs12 sm3 md3>
          <h2 class="font-weight-light headline">
            GST Reports 
          </h2>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 sm3 md3>
          <v-select
          class="select-firm"
            :items="[
              {
                      text: 'All Accounts',
                      value: 'All Accounts'
                    }, {
                      text: 'CGST Accounts',
                      value: 'CGST Accounts'
                    }, {
                      text: 'SGST Accounts',
                      value: 'SGST Accounts'
                    }, {
                      text: 'IGST Accounts',
                      value: 'IGST Accounts'
                    }, {
                      text: 'CGST+SGST Accounts',
                      value: 'CGST+SGST Accounts'
                    }
              ]"
            label="Select GST Category"
            v-model="selectedAccount"
            clearable
          ></v-select>
        </v-flex>
      </v-toolbar>
      <v-toolbar  class="mb" color="white white--text" flat>
        <v-flex xs12 sm4 md4>
          <v-select
            item-text="name"
            return-object
            :items="firmsByBrand"
            label="Select Firm"
            v-model="selectedFirm"
            clearable
          ></v-select>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 sm3 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerFrom"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="fromDate"
              label="From Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer/>
        <v-flex xs12 sm3 md3>
          <v-menu
            :close-on-content-click="false"
            v-model="datepickerTo"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              clearable
              slot="activator"
              v-model="toDate"
              label="To Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
          </v-menu>
        </v-flex>
      </v-toolbar>
      <!-- <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm4 md4>
              <template v-if="selectedFirm">
                Firm name :
                <b>{{selectedFirm.name}}</b>
                <br />Address :
                <b>{{generateAddress(selectedFirm)}}</b>
                GSTIN :
                <b>{{selectedFirm.GST_number}}</b>
                <br />Mobile :
                <b>{{selectedFirm.mobileNumber}}</b>
                <br />Email :
                <b>{{selectedFirm.email}}</b>
                <br />
                <v-btn flat @click="printGST3()">Print</v-btn>
                <v-btn flat type="button" @click="onexport()">Excel</v-btn>
              </template>
            </v-flex>
            <v-flex xs12 sm4 md4>
              <template v-if="selectedAccount">
                Selected Account :
                <b>{{selectedAccount}}</b>
                <br />
              </template>
              <template v-if="fromDate">
                Selected From Date :
                <b>{{new Date(fromDate).toLocaleDateString('en-GB')}}</b>
                <br />
              </template>
              <template v-if="toDate">
                Selected To Date :
                <b>{{new Date(toDate).toLocaleDateString('en-GB')}}</b>
              </template>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card> -->
      <v-layout row wrap>
        <v-flex xs6>
          <table class="fl2-table">
            <thead>
              <tr>
                <th colspan="6">
                  <h2 style="display: contents;">OUTWARDS</h2>
                  <v-btn style="float: right;">
                    <v-icon>add</v-icon>
                    &nbsp; Add
                  </v-btn>
                </th>
              </tr>
              <tr>
                <th>Date</th>
                <th>3%</th>
                <th>5%</th>
                <th>12%</th>
                <th>18%</th>
                <th>28%</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in buyerInvoices" v-bind:key="'outward'+index">
                <td class="font-weight-bold" v-if="item.date"> {{new Date(item.date).toLocaleDateString('en-GB')}}</td>
                <!-- <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td> -->
                <td class="font-weight-bold" v-if="item.val_3">{{item.val_3 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_5">{{item.val_5  || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_12">{{item.val_12  || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_18">{{item.val_18  || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_28">{{item.val_28  || 0 | amount}}</td><td v-else>0</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total</td>
                <td class="font-weight-bold" v-if="totalBuyer && totalBuyer.val_3">{{totalBuyer.val_3 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalBuyer && totalBuyer.val_5">{{totalBuyer.val_5 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalBuyer && totalBuyer.val_12">{{totalBuyer.val_12 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalBuyer && totalBuyer.val_18">{{totalBuyer.val_18 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalBuyer && totalBuyer.val_28">{{totalBuyer.val_28 || 0 | amount}}</td><td v-else>0</td>
              </tr>
            </tbody>
          </table>
        </v-flex>
        <v-flex xs6>
          <table class="fl2-table">
            <thead>
              <tr>
                <th colspan="6">
                  <h2 style="display: contents;">INWARD</h2>
                  <v-btn style="float: right;">
                    <v-icon>add</v-icon>
                    &nbsp; Add 
                  </v-btn>
                </th>
              </tr>
              <tr>
                <th>Date</th>
                <th>3%</th>
                <th>5%</th>
                <th>12%</th>
                <th>18%</th>
                <th>28%</th>
              </tr>
            </thead>

            <tbody>
               <tr v-for="(item, index) in sellerInvoices" v-bind:key="'inward'+index">
                <td class="font-weight-bold" v-if="item.date"> {{new Date(item.date).toLocaleDateString('en-GB')}}</td>
                <!-- <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td> -->
                <td class="font-weight-bold" v-if="item.val_3">{{item.val_3 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_5">{{item.val_5 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_12">{{item.val_12 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_18">{{item.val_18 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="item.val_28">{{item.val_28 || 0 | amount}}</td><td v-else>0</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Total</td>
                <td class="font-weight-bold" v-if="totalSeller && totalSeller.val_3">{{totalSeller.val_3   || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalSeller && totalSeller.val_5">{{totalSeller.val_5   || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalSeller && totalSeller.val_12">{{totalSeller.val_12 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalSeller && totalSeller.val_18">{{totalSeller.val_18 || 0 | amount}}</td><td v-else>0</td>
                <td class="font-weight-bold" v-if="totalSeller && totalSeller.val_28">{{totalSeller.val_28 || 0 | amount}}</td><td v-else>0</td>
              </tr>
            </tbody>
          </table>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { convertToPDFGST_3 } from "../../utils/pdfmake";
import { convertToExcelGST_3 } from "../../utils/excelExport";

import XLSX from "xlsx";
export default {
  data() {
    return {
      selectedFirm: null,
      selectedAccount: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      totalBuyer : null,
      totalSeller : null,
      buyerInvoices : [],
      sellerInvoices : [],
    };
  },
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.brand));
    this.getInvoice();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","brandFinYear"]),
    firmsByBrand1() {
      return this.firms.filter(item => item["brand"] === this.selectedBrand);
    },
    // current brands firm list
    firmsByBrand () {
        // return selected brand firms
        let firmsB = this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
          firmsB.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
            }
          })
        return firmsB;
    },
  },
  methods: {
    toggle(item) {
      item.expand = !item.expand;
    },
    // renderDate(timeStamp) {
    //   if (timeStamp) {
    //     return new Date(timeStamp).toLocaleDateString("en-GB");
    //   }
    //   return "--";
    // },
    getInvoice() {
      let invoiceOfFirm = this.invoices.filter(item => {
        return (
          item["brand"] === this.selectedBrand &&
          ( this.selectedFirm ? this.selectedFirm[".key"] === item["firm"] : true)
        );
      });
      let buyerInvoices = [];
      let sellerInvoices = [];
      let totalBuyer = {
        val_3 : 0,
        val_5 : 0,
        val_12 : 0,
        val_18 : 0,
        val_28 : 0
      };
      let totalSeller = {
        val_3 : 0,
        val_5 : 0,
        val_12 : 0,
        val_18 : 0,
        val_28 : 0
      };
      let toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      invoiceOfFirm.map(invoice => {
        if (
          !invoice.return &&
          (fromDate ? invoice.date >= fromDate : true) &&
          (toDate ? invoice.date <= toDate : true) && 
          (this.selectedAccount && (this.selectedAccount === "CGST Accounts" || this.selectedAccount === "SGST Accounts" || this.selectedAccount === "CGST+SGST Accounts") ? invoice.gstType ===  "SGST|CGST" : true) && 
          (this.selectedAccount && this.selectedAccount === "IGST Accounts" ? invoice.gstType ===  "IGST" : true)
        ) {
          invoice.items && invoice.items.map((item)=>{
            switch(item.taxableGST_rate){
              
              case 3 : {
                if (invoice.isBuyer) {
                  buyerInvoices.push({
                    val_3 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalBuyer.val_3 +=Number.parseFloat(item.GSTValue)
                } else {
                  sellerInvoices.push({
                    val_3 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalSeller.val_3 +=Number.parseFloat(item.GSTValue)
                }
                break;
              }
              case 5 : {
                if (invoice.isBuyer) {
                  buyerInvoices.push({
                    val_5 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalBuyer.val_5 +=Number.parseFloat(item.GSTValue)
                } else {
                  sellerInvoices.push({
                    val_5 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalSeller.val_5 +=Number.parseFloat(item.GSTValue)
                }
                break;
              }
              case 12 : {
                if (invoice.isBuyer) {
                  buyerInvoices.push({
                    val_12 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalBuyer.val_12 +=Number.parseFloat(item.GSTValue)
                } else {
                  sellerInvoices.push({
                    val_12 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalSeller.val_12 +=Number.parseFloat(item.GSTValue)
                }
                break;
              }
              case 18 : {
                if (invoice.isBuyer) {
                  buyerInvoices.push({
                    val_18 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalBuyer.val_18 +=Number.parseFloat(item.GSTValue)
                } else {
                  sellerInvoices.push({
                    val_18 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalSeller.val_18 +=Number.parseFloat(item.GSTValue)
                }
                break;
              }
              case 28 : {
                if (invoice.isBuyer) {
                  buyerInvoices.push({
                    val_28 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalBuyer.val_28 +=Number.parseFloat(item.GSTValue)
                } else {
                  sellerInvoices.push({
                    val_28 : Number.parseFloat(item.GSTValue),
                    date : invoice.date
                  })
                  totalSeller.val_28 +=Number.parseFloat(item.GSTValue)
                }
                break;
              }
              default : {
                console.log(JSON.stringify(item,null,4))
                break;
              }
            }
          });
          // console.log("ss")
          this.totalBuyer = totalBuyer;
          this.totalSeller = totalSeller;
          this.sellerInvoices = sellerInvoices;
          this.buyerInvoices = buyerInvoices;
        }
      });
    },
    printGST3() {
      let firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      let doc = convertToPDFGST_3({
        firm: firm,
        inwardSupplies: this.inwardSupplies,
        outwardSupplies: this.outwardSupplies
      });
      pdfMake.createPdf(doc).download();
    },
    onexport() {
      let firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      let wb = convertToExcelGST_3({
        selectedFirm: firm,
        inwardSupplies: this.inwardSupplies,
        outwardSupplies: this.outwardSupplies
      });
      XLSX.writeFile(wb, "GST3_" + new Date().getTime() + ".xlsx"); // name of the file is 'book.xlsx'
    },
    generateAddress(user) {
      let address = "";
      if (user.block) {
        address = `${user.block}`;
      }
      if (user.village) {
        address = `${address ? address + ", " : ""}${user.village}`;
      }
      if (user.tehsil) {
        address = `${address ? address + ", " : ""}${user.tehsil}`;
      }
      if (user.state) {
        address = `${address ? address + ", " : ""}${user.state}`;
      }
      return address;
    },
  },
  watch: {
    selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        //this.setData();
      }
    },
    toDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        
        this.getInvoice();
        //this.setData();
      }
    },
    fromDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        // this.setData();
      }
    },
    selectedAccount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        // this.setData();
      }
    }
  }
};
</script>

<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
} 
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
} */
.disabledCard {
  background: lightgray;
}

/* .ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
} */

.fl2-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl2-table td,
.fl2-table th {
  text-align: center;
  padding: 8px;
}

.fl2-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl2-table thead th {
    color: #ffffff;
    background: #15155D;
    border: 1px solid white;
}

.fl2-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/GSTReports/gstAccounts.vue